import { call, put, takeLatest, all } from "redux-saga/effects"
import React from "react"
import axios from "axios"
import { first, flatMap, has, last } from "lodash"
import { push } from "connected-react-router"
import { arrayToTree } from "performant-array-to-tree"
import {
  exportDivisionSegment,
} from "../../utils/segment/Division/divisionTrack"

import {
  HAS_DIVISIONS_WATCHER,
  GET_TABLE_WATCHER,
  UPLOAD_TEMPLATE_WATCHER,
  GET_TEMPLATE_DIVISION_WATCHER,
  GET_SUBDIVISIONS_TABLE_WATCHER,
  GET_DIVISIONS_UNASSIGNED_WATCHER,
  ADD_SUBDIVISION_TABLE_WATCHER,
  DELETE_SUBDIVISION_TABLE_WATCHER,
  GET_DIVISION_PARENTS_WATCHER,
  SELECT_DIVISION_SUPERIOR_WATCHER,
  DELETE_DIVISION_TABLE_WATCHER,
  GET_COLLABORATORS_TABLE_WATCHER,
  DELETE_DIVISIONS_WATCHER,
  CREATE_DIVISION_WATCHER,
} from "./constants"
import {
  hasDivisionsSucces,
  getDivisionsSuccess,
  getDivisionsFailed,
  uploadTemplateSuccess,
  getTemplateSuccess,
  getTemplateFailed,
  getSubdivisionsTableSuccess,
  getDivisionsUnassignedSuccess,
  getDivisionsUnassignedFailed,
  addSubdivisionTableFailed,
  deleteSubdivisionTableSuccess,
  deleteSubdivisionTableFailed,
  getDivisionParentsSuccess,
  selectDivisionSuperiorSuccess,
  selectDivisionSuperiorFailed,
  getDivisionsWatcher,
  getCollaboratorsTableSuccess,
  deleteDivisionsFailed,
  uploadTemplateFailed,
  deleteDivisionTableFailed,
  createDivisionSuccess,
  createDivisionFailed,
} from "./actions"
import { getCollaboratorsApi } from "../Collaborators/saga"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN,LOCAL_VISMA_PEOPLE_SYNC_ENABLED } from "../../utils/storage"
import { toggleCreateModal } from "../OrganizationPage/actions"
import DOMPurify from "dompurify"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageSuccessX(messagex) {
  const sanitizedHTML = DOMPurify.sanitize(messagex);
  message.success(
    <div
      className="messageAntd"
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />,
    5
  )
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// HAS DIVISIONS
function hasDivisionsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/has/divisions`,
  })
}

export function* hasDivisionssssSaga() {
  try {
    const { data, status } = yield call(hasDivisionsApi)

    if (status === 200) {
      yield put(hasDivisionsSucces(data.hasData))
    }
  } catch (e) {}
}

// GET DIVISIONS
function getEmployees() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/count/employees`,
  })
}

function getSubdivisions() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/count/subdivisions`,
  })
}

function getDivisionsApi(payload) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions?relation=divisionparents`,
    params: payload && payload.params ? payload.params : {},
  })
}

let lastChildrendsArray = []

function getArrayOfLastChildrens(tree) {
  if (!tree) return

  if (tree.children.length > 0) {
    lastChildrendsArray = [
      ...lastChildrendsArray,
      tree.children[tree.children.length - 1].data.id_division,
    ]
    for (let i = 0; i < tree.children.length; i++) {
      getArrayOfLastChildrens(tree.children[i])
    }
  }
  return lastChildrendsArray
}

const drawArray = []
let drawLine = []

function drawLines(tree, prev) {
  if (tree.children.length > 0) {
    for (let i = 0; i < tree.children.length; i++) {
      if (i == tree.children.length - 1) {
        // LLeva una L por last step
        if (tree.children[i].level != 1) {
          drawLine = [...prev, ["L"]]
        }
        prev.push(["x"])
        return drawLines(tree.children[i], prev)
        // return [id -> drawLine] + draw lines
      }
      // lleva T
      if (tree.children[i].level != 1) {
        drawLine = [...prev, ["T"]]
      }
      prev.push(["I"])
      return drawLines(tree.children[i], prev)
    }
  }
}

function getDivisionsApiPaginated(payload) {
  const page = payload?.page || 1;
  const perPage = payload?.perPage || 15;

  let url = `${process.env.API_URL}v2/companies/${LOCAL_COMPANY_ID()}/divisions?relation=divisionparents&page=${page}&perPage=${perPage}`;

  if (payload?.sortField) {
    url += `&sortField=${payload.sortField}`;
  }

  if (payload?.sortOrder) {
    url += `&sortOrder=${payload.sortOrder}`;
  }

  if (Array.isArray(payload?.divisions) && payload.divisions.length > 0) {
    const divisionsParam = payload.divisions.map(division => `divisions[]=${encodeURIComponent(division)}`).join('&');
    url += `&${divisionsParam}`;
  }

  if (Array.isArray(payload?.divisions_parent) && payload.divisions_parent.length > 0) {
    const divisionsParentParam = payload.divisions_parent.map(divisionParent => `divisions_parent[]=${encodeURIComponent(divisionParent)}`).join('&');
    url += `&${divisionsParentParam}`;
  }

  if (Array.isArray(payload?.levels) && payload.levels.length > 0) {
    const levelsParam = payload.levels.map(level => `levels[]=${encodeURIComponent(level)}`).join('&');
    url += `&${levelsParam}`;
  }

  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: url,
    params: payload && payload ? payload : {},

  });
}



export function* getDivisionsSaga(action) {
  try {
    let payload = []
    if (action.payload?.params?.table) {

      const { data, status } = yield call(getDivisionsApiPaginated, action.payload.params);
     
      const params = {
        data: data.data,
        empty: data.data.length === 0,
        current_page: data.current_page,
        total: data.total,
        per_page: data.per_page,
        divisions: data.divisions,
        divisionsSimple: data.divisions,
        divisionsParent: data.divisionsParent,
        levels: data.levels
      };
      payload = {
        params,
      };

    }
    else{

    const [data, subdivisions, employees] = yield all([
      call(getDivisionsApi, action.payload),
      call(getSubdivisions),
      call(getEmployees),
    ])

    const parsedData = data.data.data.map((item, index) => {
      let newItemDivisionParent

      if (item.divisionparents.length == 1) {
        newItemDivisionParent = {
          name: item.divisionparents[0].name,
          id: item.divisionparents[0].id_division,
        }
      } else {
        newItemDivisionParent = {
          name: item.company_name,
          id: item.divisionparents.length
            ? item.divisionparents[0].id_division
            : null,
          html: true,
        }
      }

      const employeesCount = employees.data.data.find(
        (employee) => employee.id_division == item.id_division
      )
      const subdivisionsCount = subdivisions.data.data.find(
        (subdivision) => subdivision.id_division == item.id_division
      )

      const newItem = {
        index,
        id_company: item.id_company,
        id_division: item.id_division,
        division: item.name,
        id_parent: newItemDivisionParent.id,
        parentdivision: newItemDivisionParent,
        employees:
          typeof employeesCount === "undefined" ? 0 : employeesCount.employees,
        subdivisions:
          typeof subdivisionsCount === "undefined"
            ? 0
            : subdivisionsCount.subdivisions,
        level: item.level,
        ambassadors: item.ambassadors,
      }

      return newItem
    })

    const empty = !!(
      (parsedData.length == 0 && action.payload == undefined) ||
      (parsedData.length == 0 && action.payload == 0)
    )

    const tree = arrayToTree(parsedData, {
      id: "id_division",
      parentId: "id_parent",
    })

    const lastOfTree = getArrayOfLastChildrens(tree[0])

    const toExpand = parsedData.filter((row) => {
      if (row.level == 1) {
        return row.id_division
      }
    })

    const params = {
      data: parsedData,
      empty,
      divisionsSimple: data.data.divisionsSimple
    }

    const expandedRows = toExpand.flatMap((item) => item.id_division)


    if (action.payload && action.payload.first) {
      payload = {
        params,
        tree,
        lastOfTree,
        expandedRows,
        first: true,
      }
    } else {
      payload = {
        params,
        tree,
        lastOfTree,
        first: false,
      }
    }
    }
    
    let hasSinAsignarDivision = false
    if(LOCAL_VISMA_PEOPLE_SYNC_ENABLED()){
      payload.params.data = payload.params.data.filter((item) => {      
        if((item.division === 'Sin Asignar' || item.division === "sin asignar" || item.division === "Sin asignar") && item.employees === 0){
          hasSinAsignarDivision = true
          return false
        }
        return true
      })
  
      payload.params.divisions = payload.params.data.filter((item) => {
        if(hasSinAsignarDivision && (item.division === 'Sin Asignar' || item.division === "sin asignar" || item.division === "Sin asignar")){
          return false
        }
        return true
      })  
    }
   
    
    //console.log("params", params.divisions)
    yield put(getDivisionsSuccess(payload))
  } catch (e) {
    yield put(getDivisionsFailed())
  }
}

// UPLOAD TEMPLATE
function uploadTemplate(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

export function* uploadTemplateSaga(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    yield call(uploadTemplate, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateProgress)

      if (data.status === 200) {
        break
      }
    }
    // const otherData  = yield call(uploadTemplateSummary);
    yield put(uploadTemplateSuccess())
    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(push("/organization/divisions/summary"))
  } catch (error) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar el archivo")
    yield put(uploadTemplateFailed())
  }
}

// GET EXCEL
function getDivisionTemplateApi(isTemplate) {
  const asdf = isTemplate ? "/template" : ""
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/export/xlsx${asdf}`,
  })
}

function getDivisionTemplateApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/export/xlsx/progress`,
  })
}

function donwloadDivisionTemplate(url) {
  location.replace(url)
}

export function* getDivisionTemplateSaga(action) {
  const listDivisions = yield call(getDivisionsApi)

  try {
    yield call(
      messageProgress,
      action.payload ? "Descargando plantilla" : "Descargando archivo"
    )

    yield call(getDivisionTemplateApi, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getDivisionTemplateApiProgress)
      if (data.status === 200) {
        break
      }
    }

    yield call(donwloadDivisionTemplate, data.data[0].url)
    yield call(messageDestroy)
    yield call(
      messageSuccess,
      action.payload
        ? getStatusDivisionExistExport("Plantilla descargada", listDivisions)
        : getStatusDivisionExistExport("Archivo descargado", listDivisions)
    )
    yield put(getTemplateSuccess())
  } catch (e) {
    yield call(messageDestroy)
    yield call(
      messageFailed,
      action.payload
        ? getStatusDivisionExistExport(
            "Error al descargar la plantilla",
            listDivisions
          )
        : getStatusDivisionExistExport(
            "Error al descargar archivo",
            listDivisions
          )
    )
    yield put(getTemplateFailed())
  }
}

function getStatusDivisionExistExport(status, listDivisions) {
  exportDivisionSegment(
    status,
    "exportDivisions",
    listDivisions && listDivisions.status === 200
      ? listDivisions.data.data.length
      : ""
  )
  return status
}

// GET SUBDIVISIONS TABLE
export function getSubdivisionsTableApi(idDivision) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/subdivisions`,
  })
}

export function* getSubdivisionsTable(action) {
  try {
    const { data, status } = yield call(getSubdivisionsTableApi, action.payload)

    if (status === 200) {
      yield put(getSubdivisionsTableSuccess(data))
    }
  } catch (error) {}
}

// DIVISIONS UNASSIGNED
export function getDivisionsUnassignedApi(idDivision) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/potential/subdivision`,
  })
}

export function* getDivisionsUnassigned(action) {
  try {
    const { data } = yield call(getDivisionsUnassignedApi, action.payload)

    yield put(getDivisionsUnassignedSuccess(data.data))
  } catch (error) {
    yield put(getDivisionsUnassignedFailed())
    returnMessage(error)
  }
}

// ADD SUBDIVISION TABLE
export function addSubdivisionTableApi({ idDivision, idSubdivision }) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/subdivision/`,
    data: { id_division: idSubdivision },
  })
}

export function* addSubdivisionTable(action) {
  try {
    const { status, data } = yield call(addSubdivisionTableApi, action.payload)

    if (status === 200) {
      const params = { payload: 0 }
      const otherParams = { payload: action.payload.idDivision }
      yield call(getDivisionsUnassigned, otherParams)
      yield call(messageSuccess, data.data.msj)
      yield call(getSubdivisionsTable, otherParams)
      yield call(getDivisionsSaga, params)
    }
  } catch (error) {
    yield put(addSubdivisionTableFailed())
    returnMessage(error)
  }
}

// DELETE SUBDIVISION TABLE
export function deleteSubdivisionTableApi({ idDivision, idSubdivision }) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/subdivision/${idSubdivision}`,
  })
}

export function* deleteSubdivisionTable(action) {
  try {
    const { data, status } = yield call(
      deleteSubdivisionTableApi,
      action.payload
    )

    if (status === 200) {
      const params = { payload: action.payload.idDivision }
      const otherParams = { payload: 0 }

      yield call(getDivisionsUnassigned, params)
      yield call(getSubdivisionsTable, params)
      yield put(deleteSubdivisionTableSuccess(data.data))
      yield call(getDivisionsSaga, otherParams)
    }
  } catch (error) {
    yield put(deleteSubdivisionTableFailed(""))
    returnMessage(error)
  }
}

// GET DIVISION PARENTS
function getDivisionParentsTableApi(id) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${id}/potential/parentdivision`,
  })
}

export function* getDivisionParentsTable(action) {
  try {
    const { data } = yield call(getDivisionParentsTableApi, action.payload)
    yield put(getDivisionParentsSuccess(data.data))
  } catch (error) {}
}

// SELECT PARENT
export function selectDivisionSuperiorApi({ idDivision, idParent }) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/parentdivision`,
    data: { id_parent: idParent },
  })
}

export function* selectDivisionSuperior(action) {
  try {
    const { data, status } = yield call(
      selectDivisionSuperiorApi,
      action.payload
    )
    if (status === 200) {
      const params = { payload: 0 }

      yield put(getDivisionsWatcher(params))
      yield put(selectDivisionSuperiorSuccess())
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    yield put(selectDivisionSuperiorFailed())
    yield call(messageFailed, "Error al agregar división superior")
  }
}

// DELETE DIVISION
export function deleteDivisionTableApi(idDivision) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}`,
  })
}

export function* deleteDivisionTable(action) {
  try {
    const { status, data } = yield call(deleteDivisionTableApi, action.payload)

    if (status === 200) {
      const params = { payload: 0 }

      yield call(getDivisionsSaga, params)
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    yield put(deleteDivisionTableFailed())
    returnMessage(error)
  }
}

// GET COLLABORATORS DIVISION
export function getCollaboratorsDivisionApi(idDivision) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/employees`,
  })
}

export function* getCollaboratorsDivision(action) {
  try {
    const { data, status } = yield call(
      getCollaboratorsDivisionApi,
      action.payload
    )

    if (status === 200) {
      yield put(getCollaboratorsTableSuccess(data))
    }
  } catch (error) {
    returnMessage(error)
  }
}

// DELETE DIVISIONS
export function deleteDivisionsApi(divisions) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/batch?${divisions}`,
  })
}

export function* deleteDivisions(action) {
  try {
    const { data, status } = yield call(deleteDivisionsApi, action.payload)

    if (status === 200) {
      yield put(getDivisionsWatcher())
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    yield put(deleteDivisionsFailed())
    returnMessage(error)
  }
}

export const createDivisionApi = (payload) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions`,
    params: payload,
  })
}

export function* createDivisionSaga(action) {
  try {
    const { data } = yield call(createDivisionApi, action.payload)
    yield put(createDivisionSuccess())
    yield call(messageSuccessX, data.data.msj)
    yield put(toggleCreateModal(false))
    yield call(getDivisionsSaga, { payload: { params: { table: true } } })
  } catch (e) {
    yield put(createDivisionFailed())
    returnMessage(e)
  }
}

export default function* getDivisionWatcherSaga() {
  yield takeLatest(HAS_DIVISIONS_WATCHER, hasDivisionssssSaga)
  yield takeLatest(GET_TABLE_WATCHER, getDivisionsSaga)
  yield takeLatest(UPLOAD_TEMPLATE_WATCHER, uploadTemplateSaga)
  yield takeLatest(GET_TEMPLATE_DIVISION_WATCHER, getDivisionTemplateSaga)
  yield takeLatest(GET_SUBDIVISIONS_TABLE_WATCHER, getSubdivisionsTable)
  yield takeLatest(GET_DIVISIONS_UNASSIGNED_WATCHER, getDivisionsUnassigned)
  yield takeLatest(ADD_SUBDIVISION_TABLE_WATCHER, addSubdivisionTable)
  yield takeLatest(DELETE_SUBDIVISION_TABLE_WATCHER, deleteSubdivisionTable)
  yield takeLatest(GET_DIVISION_PARENTS_WATCHER, getDivisionParentsTable)
  yield takeLatest(SELECT_DIVISION_SUPERIOR_WATCHER, selectDivisionSuperior)
  yield takeLatest(DELETE_DIVISION_TABLE_WATCHER, deleteDivisionTable)
  yield takeLatest(GET_COLLABORATORS_TABLE_WATCHER, getCollaboratorsDivision)
  yield takeLatest(DELETE_DIVISIONS_WATCHER, deleteDivisions)
  yield takeLatest(CREATE_DIVISION_WATCHER, createDivisionSaga)
}
